import * as types from "./types";
import awsExports from "./aws-exports";
import {
  faTiktok,
  faFacebook,
  faInstagram,
  faYoutube,
  faYelp,
} from "@fortawesome/free-brands-svg-icons";
import { createSvgIcon, SvgIconProps } from "@mui/material";

// https://create-react-app.dev/docs/adding-custom-environment-variables/
// NODE_ENV can only be:
//   - development: when you run "npm start"
//   - production: when you run "npm run build"
export const API_DOMAIN =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://api.aagent.co";

const stage = process.env.NODE_ENV === "development" ? "dev" : "prod";
const identityPoolId =
  stage === "prod"
    ? "us-east-1:75fa1cb8-3ae1-47e5-a38f-34acaefe33ed"
    : "us-east-1:7f0af29e-12f3-400e-bb16-a92cadf6e0b8";

// References:
// https://docs.amplify.aws/lib/storage/getting-started/q/platform/js/#manual-setup-import-storage-bucket
// https://docs.aws.amazon.com/AmazonS3/latest/API/browser-based-uploads-aws-amplify.html
const storageConfig = {
  Auth: {
    identityPoolId,
    region: awsExports.aws_cognito_region,
    userPoolId: awsExports.aws_user_pools_id,
    userPoolWebClientId: awsExports.aws_user_pools_web_client_id,
  },
  Storage: {
    AWSS3: {
      bucket: `anonymous-agent-${stage}-s3`,
      region: awsExports.aws_project_region,
    },
  },
};
export const AMPLIFY_CONFIG = {
  ...awsExports,
  ...storageConfig,
};

const _XiaoHongShuIcon = createSvgIcon(
  <path d="M972.288 79.36c-7.68-10.24-16.896-19.968-27.648-27.648C922.624 35.328 896 25.6 866.816 25.6H157.184c-29.184 0-56.32 9.728-78.336 26.112-10.24 7.68-19.968 16.896-27.648 27.648-15.872 21.504-25.6 48.64-25.6 77.824v709.632c0 29.184 9.728 56.32 26.112 77.824 7.68 10.24 16.896 19.968 27.648 27.648 22.016 16.384 48.64 26.112 77.824 26.112h709.632c29.184 0 56.32-9.728 77.824-26.112 10.24-7.68 19.968-16.896 27.648-27.648 16.384-22.016 26.112-48.64 26.112-77.824V157.184c0-29.184-10.24-56.32-26.112-77.824zM373.76 469.504c15.36-34.304 33.28-68.096 49.664-101.888h56.832c-13.824 27.648-29.696 55.296-39.424 81.408 23.04-1.536 44.032-2.56 69.12-4.096-13.312 26.624-25.088 50.176-36.352 73.728-1.536 3.072-3.072 6.656-4.608 9.728-12.288 24.576-12.288 24.576 14.848 25.088 3.072 0 5.632 0.512 10.752 1.024-7.68 14.848-14.336 28.672-21.504 41.984-1.024 2.048-4.608 4.608-6.656 4.608-19.968 0-40.448 0.512-60.416-1.536-14.336-1.536-19.968-12.8-14.336-26.112 6.656-16.896 14.848-33.28 22.528-50.176 2.56-5.632 5.12-11.264 8.704-19.968h-27.648c-23.04-1.536-31.232-12.288-21.504-33.792z m-275.968 181.248c-12.288-20.992-23.04-40.448-34.304-59.904 0-2.56 22.016-68.608 16.896-144.384h59.904c0.512 0.512 2.56 141.312-42.496 204.288z m139.776-7.168c0.512 35.328-23.552 35.328-23.552 35.328h-34.304l-36.352-47.616h37.888V367.104h56.832c0.512 86.528 0 189.952-0.512 276.48z m82.944 4.096c-27.136-24.064-41.984-95.232-41.472-201.216h56.32c-4.096 55.808 13.824 130.56 13.824 130.56s-16.896 36.352-28.672 70.656z m123.392 25.088c-1.536 3.072-6.656 5.632-9.728 5.632-26.624 0.512-53.248 0-83.456 0 11.264-23.04 20.992-41.472 29.184-57.856H471.04c-10.24 19.968-18.432 36.352-27.136 52.224z m232.448 6.144H472.064c9.728-19.456 27.648-54.784 27.648-54.784H558.08V445.44h-36.352V389.632h131.584v55.296h-35.84V624.64h59.392l-0.512 54.272z m270.336-41.472c0 41.472-40.448 39.936-40.448 39.936h-52.736l-22.016-47.104h56.832s0.512-43.008 0-57.344c-0.512-12.288-7.168-20.48-19.968-20.48-25.088-0.512-50.688 0-78.848 0v125.44h-56.32V552.96h-56.832V494.592h55.296V445.44h-36.864V390.656h37.376v-23.552h56.832l0.512 23.552h45.568s41.984-1.024 41.984 39.936c0 12.288 0.512 51.712 0.512 65.024 48.128 0 68.608 9.728 68.608 43.008l0.512 98.816z m-24.064-190.464h-30.208v-29.184c0-10.752 5.12-20.48 14.336-26.112 10.24-6.656 24.064-10.752 37.376 2.048l1.536 1.536c17.92 19.968 3.584 51.712-23.04 51.712z" />,
  "XiaoHongShu"
);
export const XiaoHongShuIcon = (props: SvgIconProps) => (
  <_XiaoHongShuIcon {...props} viewBox="0 0 1024 1024" />
);

const _GoogleMapIcon = createSvgIcon(
  <g>
    <path
      d="M182.442,0H34.53C15.49,0,0,15.491,0,34.531v147.913c0,19.04,15.49,34.53,34.53,34.53h147.912
      c19.041,0,34.532-15.49,34.532-34.53V34.531C216.975,15.491,201.483,0,182.442,0z M135.731,48.122
      C135.731,29.858,150.59,15,168.852,15c18.264,0,33.122,14.858,33.122,33.122c0,12.021-18.405,41.336-33.122,61.603
      C154.137,89.458,135.731,60.143,135.731,48.122z M15,34.531C15,23.762,23.761,15,34.53,15h99.463
      c-8.208,8.635-13.262,20.296-13.262,33.122c0,7.455,3.886,17.633,9.306,28.209l-26.846,26.846
      c-0.003,0.002-0.005,0.004-0.008,0.007c-0.003,0.003-0.005,0.005-0.007,0.008l-86.695,86.695c-0.95-2.296-1.481-4.808-1.481-7.442
      V34.531z M34.53,201.975c-2.635,0-5.146-0.531-7.442-1.481l81.399-81.398l81.398,81.398c-2.296,0.95-4.808,1.481-7.443,1.481H34.53
      z M201.975,182.444c0,2.635-0.531,5.146-1.481,7.442l-81.398-81.399l18.555-18.554c10.69,17.785,22.918,33.86,25.262,36.903
      c1.42,1.843,3.614,2.923,5.941,2.923c2.327,0,4.521-1.08,5.941-2.923c2.485-3.227,16.085-21.106,27.181-40.141V182.444z"
    />
    <path
      d="M63.964,98.25c20.009,0,36.287-16.278,36.287-36.287c0-4.142-3.357-7.5-7.5-7.5H63.964c-4.143,0-7.5,3.358-7.5,7.5
      c0,4.142,3.357,7.5,7.5,7.5h19.923C80.848,77.511,73.063,83.25,63.964,83.25c-11.737,0-21.286-9.549-21.286-21.287
      c0-11.737,9.549-21.286,21.286-21.286c5.684,0,11.03,2.214,15.052,6.234c2.93,2.928,7.678,2.928,10.607-0.002
      c2.928-2.929,2.927-7.678-0.002-10.606c-6.854-6.852-15.967-10.625-25.657-10.625c-20.008,0-36.286,16.278-36.286,36.286
      C27.678,81.972,43.956,98.25,63.964,98.25z"
    />
  </g>,
  "GoogleMap"
);
export const GoogleMapIcon = (props: SvgIconProps) => (
  <_GoogleMapIcon {...props} viewBox="0 0 216.975 216.975" />
);

export const SOCIAL_MEDIA_TO_ICON = {
  [types.SocialMediaPlatform.FACEBOOK]: faFacebook,
  [types.SocialMediaPlatform.INSTAGRAM]: faInstagram,
  [types.SocialMediaPlatform.TIKTOK]: faTiktok,
  [types.SocialMediaPlatform.YOUTUBE]: faYoutube,
  [types.SocialMediaPlatform.XIAO_HONG_SHU]: XiaoHongShuIcon,
};

export const PUBLIC_SOCIAL_MEDIAS = [
  types.SocialMediaPlatform.INSTAGRAM,
  types.SocialMediaPlatform.FACEBOOK,
  types.SocialMediaPlatform.TIKTOK,
  types.SocialMediaPlatform.XIAO_HONG_SHU,
];

export const REVIEW_PLATFORM_TO_ICON = {
  [types.ReviewPlatform.GOOGLE_MAP]: GoogleMapIcon,
  [types.ReviewPlatform.YELP]: faYelp,
};
